<template>
  <div
    :class="
      billStatus == '0'
        ? 'ccui-app-box-iframe-operate-container'
        : 'ccui-app-iframe-no-operate-container'
    "
  >
    <template v-if="labelShow">
      <breadcrumbSourcing
        :breadcrumb-data="breadcrumbData"
      ></breadcrumbSourcing>
      <!--      <div class="detail-info-el-Label">-->
      <!--        <el-label :type="labelType" style="height: 100px;"></el-label>-->
      <!--      </div>-->
    </template>
    <div
      :class="
        billStatus == '0'
          ? 'ccui-app-iframe-container-detail'
          : 'ccui-app-iframe-container-no-operate-detail'
      "
    >
      <div class="ccui-app-iframe-container-detail-body">
        <el-tabs class="el-tabs__customize" value="1">
          <el-tab-pane label="技术评分" name="1">
            <template v-if="subPackageFlag">
              <el-tabs class="customeTab" v-model="active">
                <el-tab-pane
                  v-for="(listItem, listIndex) in listData"
                  :key="listIndex"
                  :label="listItem.packName"
                  :name="listIndex + ''"
                >
                  <template v-if="labelType != 'ScoreComplete'">
                    <div class="customeTab-button-body">
                      <div class="fr customeTab-button">
                        <template v-if="listItem.hasScore">
                          <el-button
                            style="z-index: 1"
                            type="single-number"
                            plain
                            @click="addOrEditData(listItem, 1)"
                            >编辑</el-button
                          >
                        </template>
                        <template v-else>
                          <el-button
                            style="z-index: 1"
                            type="single-number"
                            plain
                            @click="addOrEditData(listItem, 0)"
                            >新增</el-button
                          >
                        </template>
                      </div>
                      <div class="clearfix"></div>
                    </div>
                  </template>
                  <!--<br />-->
                  <el-table :data="listItem.list" border>
                    <el-table-column
                      v-for="(item, index) in listItem.columns"
                      :key="index"
                      :show-overflow-tooltip="true"
                      v-bind="item"
                    >
                      <template
                        v-if="item.labelChild && item.labelChild.length > 0"
                      >
                        <el-table-column
                          v-for="(child, indexch) in item.labelChild"
                          :key="indexch"
                          :show-overflow-tooltip="true"
                          align="center"
                          width="130px"
                          v-bind="child"
                        >
                          <template slot="header">
                            <div class="el-tooltip" style="width: 130px">
                              {{ child.label }}
                            </div>
                          </template>
                          <template
                            v-if="
                              child.labelChild && child.labelChild.length > 0
                            "
                          >
                            <el-table-column
                              v-for="(childs, indexch) in child.labelChild"
                              :key="indexch"
                              align="center"
                              v-bind="child"
                            >
                              <template slot="header">
                                <div class="el-tooltip">{{ childs.label }}</div>
                              </template>
                              <template
                                v-if="
                                  childs.labelChild &&
                                    childs.labelChild.length > 0
                                "
                              >
                                <el-table-column
                                  v-for="(childTwo,
                                  indexch) in childs.labelChild"
                                  :key="indexch"
                                  align="center"
                                  v-bind="childTwo"
                                >
                                  <template slot="header">
                                    <div
                                      class="el-tooltip tooltip-header"
                                      :class="{
                                        'tooltip-header-flow':
                                          childTwo.label.length > 15
                                      }"
                                    >
                                      {{ childTwo.label }}
                                    </div>
                                  </template>
                                </el-table-column>
                              </template>
                            </el-table-column>
                          </template>
                        </el-table-column>
                      </template>
                      <template slot-scope="scope">
                        <el-button
                          v-if="item.type == 'link'"
                          size="mini"
                          type="text"
                          @click="viewBidFile(scope.row)"
                          >查看投标文件</el-button
                        >
                        <span v-else-if="item.money">{{
                          scope.row[item.prop]
                            ? new BigNumber(scope.row[item.prop]).toFormat(2)
                            : ""
                        }}</span>
                        <span v-else>{{ scope.row[item.prop] }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-tab-pane>
              </el-tabs>
            </template>
            <template v-else>
              <template v-for="(listItem, listIndex) in listData">
                <div :key="listIndex">
                  <template v-if="labelType != 'ScoreComplete'">
                    <div class="fr">
                      <template v-if="listItem.hasScore">
                        <el-button
                          style="z-index: 1"
                          type="single-number"
                          plain
                          @click="addOrEditData(listItem, 1)"
                          >编辑</el-button
                        >
                      </template>
                      <template v-else>
                        <el-button
                          style="z-index: 1"
                          type="single-number"
                          plain
                          @click="addOrEditData(listItem, 0)"
                          >新增</el-button
                        >
                      </template>
                    </div>
                    <div class="clearfix"></div>
                  </template>
                  <!--<br />-->
                  <el-table :data="listItem.list" border>
                    <el-table-column
                      v-for="(item, index) in listItem.columns"
                      :key="index"
                      :show-overflow-tooltip="true"
                      v-bind="item"
                    >
                      <template
                        v-if="item.labelChild && item.labelChild.length > 0"
                      >
                        <el-table-column
                          v-for="(child, indexch) in item.labelChild"
                          :key="indexch"
                          align="center"
                          v-bind="child"
                          :show-overflow-tooltip="true"
                        >
                          <template slot="header">
                            <div class="el-tooltip">{{ child.label }}</div>
                          </template>
                          <template
                            v-if="
                              child.labelChild && child.labelChild.length > 0
                            "
                          >
                            <el-table-column
                              v-for="(childs, indexch) in child.labelChild"
                              :key="indexch"
                              align="center"
                              v-bind="child"
                            >
                              <template slot="header">
                                <div class="el-tooltip">{{ childs.label }}</div>
                              </template>
                              <template
                                v-if="
                                  childs.labelChild &&
                                    childs.labelChild.length > 0
                                "
                              >
                                <el-table-column
                                  v-for="(childTwo,
                                  indexch) in childs.labelChild"
                                  :key="indexch"
                                  align="center"
                                  v-bind="childTwo"
                                >
                                  <template slot="header">
                                    <div
                                      class="el-tooltip tooltip-header"
                                      :class="{
                                        'tooltip-header-flow':
                                          childTwo.label.length > 15
                                      }"
                                    >
                                      {{ childTwo.label }}
                                    </div>
                                  </template>
                                </el-table-column>
                              </template>
                            </el-table-column>
                          </template>
                        </el-table-column>
                      </template>
                      <template slot-scope="scope">
                        <el-button
                          v-if="item.type == 'link'"
                          size="mini"
                          type="text"
                          @click="viewBidFile(scope.row)"
                          >查看投标文件</el-button
                        >
                        <span v-else-if="item.money">{{
                          scope.row[item.prop]
                            ? new BigNumber(scope.row[item.prop]).toFormat(2)
                            : ""
                        }}</span>
                        <span v-else>{{ scope.row[item.prop] }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </template>
            </template>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <template v-if="billStatus == '0'">
      <div class="operate">
        <!--<el-button-->
        <!--v-if="labelType != 'ScoreComplete' && listData[active].hasScore"-->
        <!--type="text"-->
        <!--icon="icon-ccui-edit"-->
        <!--v-preventReClick-->
        <!--@click="addOrEditData(listData[active], 1)"-->
        <!--&gt;编辑</el-button-->
        <!--&gt;-->
        <!--<el-button-->
        <!--v-if="labelType != 'ScoreComplete' && !listData[active].hasScore"-->
        <!--type="text"-->
        <!--icon="icon-ccui-edit"-->
        <!--v-preventReClick-->
        <!--@click="addOrEditData(listData[active], 0)"-->
        <!--&gt;新增</el-button-->
        <!--&gt;-->
        <el-button
          type="text"
          icon="icon-ccui-save"
          v-preventReClick
          @click="dealExpertSupScoreSubmit"
          >提交</el-button
        >
      </div>
    </template>
    <el-dialog
      :visible.sync="dialogVisible"
      title="供应商投标详细信息"
      width="1200px"
      v-if="dialogVisible"
    >
      <supplierBidDetails
        :supPackQuoteId="formData.supPackQuoteId"
        :supQuoteId="formData.supQuoteId"
        :supCode="formData.supCode"
        source="default"
      ></supplierBidDetails>
      <div slot="footer">
        <el-button
          size="mini"
          type="default-mini"
          @click="dialogVisible = false"
          >取消</el-button
        >
        <el-button
          size="mini"
          type="primary-font-mini"
          @click="dialogVisible = false"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import BigNumber from "bignumber.js";
import supplierBidDetails from "@/app/sourcingFlow/views/supplierBidDetails.vue";
import breadcrumbSourcing from "@/app/sourcingFlow/components/breadcrumb-sourcing.vue";
import {
  qryExpertScorePackListApi,
  qryExpertSupPackQuoteToScoreApi,
  qryExpertSupPackQuoteScoreApi,
  dealExpertSupScoreSubmitApi,
  qryBidEvaProcessStatusApi
} from "@/app/sourcingFlow/api/expertEvaluation.js";
import bidEvaProcessStatus from "@/app/sourcingFlow/mixins/getBidEvaProcessStatus.js";

export default {
  name: "skiiScoreList",
  components: {
    supplierBidDetails,
    breadcrumbSourcing
  },
  inject: ["reload"],
  mixins: [bidEvaProcessStatus],
  data() {
    return {
      BigNumber: BigNumber,
      breadcrumbData: {
        titname: "技术评分",
        status: JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
          .billStatusName
      },
      labelShow: false,
      labelType:
        JSON.parse(sessionStorage.getItem("bidEvaProcessStatus")).billStatus ===
        "0"
          ? "score"
          : "ScoreComplete", // 评分中：score 评分完成：ScoreComplete
      billStatus: JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
        .billStatus,
      dialogVisible: false,
      listData: [],
      active: "0",
      headers: [],
      formData: {
        supPackQuoteId: "",
        supQuoteId: 0, // 供应商报价ID
        supCode: "" // 供应商编号
      },
      columns: [],
      columnCopy: [
        {
          prop: "id",
          label: "序号",
          width: 55
        },
        {
          prop: "supName",
          label: "供应商",
          width: 200
        },
        {
          prop: "priceAmount",
          label:
            "投标金额（" + sessionStorage.getItem("moneyTypeName") + "）含税",
          width: 170,
          money: true
        },
        {
          prop: "查看投标文件",
          label: "投标文件",
          width: 170,
          type: "link"
        },
        {
          prop: "sscScoreItemBOS",
          label: "技术",
          labelChild: [],
          align: "center"
        },
        {
          prop: "supScore",
          label: "汇总得分",
          width: 110,
          align: "center"
        },
        {
          prop: "scoreDesc",
          label: "打分说明",
          width: 350
        }
      ],
      subPackageFlag: false, // 是否分包 false:不分包
      purchaseType: ""
    };
  },
  mounted() {
    let expertSourceData = JSON.parse(
      sessionStorage.getItem("expertSourceData")
    );
    this.purchaseType = expertSourceData.purchaseType;
    if (this.purchaseType == "50" || this.purchaseType == "53") {
      this.columnCopy.splice(2, 1);
      this.columns = this.columnCopy;
    } else {
      this.columns = this.columnCopy;
    }
    this.getData();
  },
  created() {
    this.$route.query.active && (this.active = this.$route.query.active);
  },
  methods: {
    init() {
      this.getData();
      this.reload();
    },
    getData() {
      qryBidEvaProcessStatusApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .joinExpertId,
        purStep: this.$router.history.current.query.menuKey
      }).then(res => {
        this.labelShow = false;
        this.billStatus = res.data.data.billStatus;
        this.labelType = this.billStatus === "0" ? "score" : "ScoreComplete";
        sessionStorage.setItem(
          "bidEvaProcessStatus",
          JSON.stringify(res.data.data)
        );
        this.$set(
          this.breadcrumbData,
          "status",
          JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
            .billStatusName
        );
        this.labelShow = true;
      });
      qryExpertScorePackListApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .joinExpertId,
        scoreItem: "0"
      }).then(res => {
        this.subPackageFlag = res.data.data.subPackageFlag;
        let arr = [];
        // subPackageFlag: false 不分包
        if (res.data.data.subPackageFlag) {
          res.data.data.notScorePack.forEach(item => {
            // 看是否流标 packStatus 1正常5流标
            if (item.packStatus == "1") {
              arr.push(
                this.qryExpertSupPackQuoteToScore(item.packId, item.packName)
              );
            }
          });
          res.data.data.hasScorePack.forEach(item => {
            // 看是否流标 packStatus 1正常5流标
            if (item.packStatus == "1") {
              arr.push(
                this.qryExpertSupPackQuoteScore(item.packId, item.packName)
              );
            }
          });
        } else {
          // 不分包 scoreFlag：true 已评分
          if (res.data.data.scoreFlag) {
            arr.push(this.qryExpertSupPackQuoteScore("", ""));
          }
        }
        Promise.all(arr).then(res => {
          // 通过包件id进行排序
          res.sort(function(a, b) {
            if (a.packId > b.packId) {
              return 1;
            } else if (a.packId < b.packId) {
              return -1;
            } else {
              return 0;
            }
          });
          res.forEach(rItem => {
            rItem.columns = JSON.parse(JSON.stringify(this.columns));
            let labelChild = [];
            rItem.list.forEach((item, index) => {
              item.id = index + 1;
              item.sscScoreBOS.forEach(aItem => {
                aItem.sscScoreItemBOS.forEach(bItem => {
                  item.scoreRule = bItem.scoreRule;
                  item.scoreWeight = bItem.scoreWeight;
                  let props = "supScore" + bItem.scoreItemId;
                  item[props] = bItem.supScore;
                  console.log(bItem, "bItem");
                  // 细则权重
                  let scoreWeightProps =
                    "maxScoreWeight-" +
                    aItem.scoreItem +
                    "-" +
                    bItem.scoreRule +
                    "-" +
                    bItem.scoreItemId;
                  item[scoreWeightProps] = bItem.scoreWeight;
                  if (
                    labelChild.filter(item => {
                      return item.prop == "supScore" + bItem.scoreItemId;
                    }).length == 0
                  ) {
                    labelChild.push({
                      prop: props,
                      label: bItem.scoreRule,
                      width: 120,
                      labelChild: [
                        {
                          prop: props,
                          label: "细则权重:" + bItem.scoreWeight,
                          width: 120,

                          money: true,
                          labelChild: [
                            {
                              prop: props,
                              label: bItem.scoreStandard,
                              width: 150
                            }
                          ]
                        }
                        // {
                        //   prop: props,
                        //       label: "细则权重:" + bItem.scoreWeight,
                        //       width: 120
                        // }
                      ]
                    });
                  }
                });
              });
            });
            if (this.purchaseType == "50" || this.purchaseType == "53") {
              if (labelChild.length < 3) {
                delete rItem.columns[5].width;
              }
              rItem.columns[3].labelChild = labelChild;
            } else {
              if (labelChild.length < 3) {
                delete rItem.columns[6].width;
              }
              rItem.columns[4].labelChild = labelChild;
            }
            console.log(rItem.columns, "columns");
          });
          this.listData = res;
        });
      });
    },
    // 专家供应商报价待评分列表查询
    qryExpertSupPackQuoteToScore(packId, packName) {
      return new Promise((resolve, reject) => {
        qryExpertSupPackQuoteToScoreApi({
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          packId: packId,
          scoreItem: "0"
        }).then(res => {
          let obj = {
            packId: packId,
            packName: packName,
            hasScore: false, // 是否评分
            list: [],
            headers: []
          };
          if (res.data.data && res.data.data.length > 0) {
            // res.data.data.forEach(item => {
            //   item.sscScoreBOS.forEach(sscScoreBOItem => {
            //     // 将评分项排序保证每条数据对应正确
            //     sscScoreBOItem.sscScoreItemBOS.sort(function(a, b) {
            //       return a.scoreItemId - b.scoreItemId;
            //     });
            //   });
            // });
            // obj.list = res.data.data;
            let flag = true;
            res.data.data[0].sscScoreBOS.forEach(item => {
              if (flag) {
                if (item.scoreItem === "0") {
                  flag = false;
                  obj.headers = Object.assign([], item.sscScoreItemBOS);
                }
              }
            });
          }
          resolve(obj);
        });
      });
    },
    // 专家供应商报价评分列表查询
    qryExpertSupPackQuoteScore(packId, packName) {
      return new Promise((resolve, reject) => {
        qryExpertSupPackQuoteScoreApi({
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          packId: packId,
          joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .joinExpertId,
          scoreItem: "0"
        }).then(res => {
          let obj = {
            packId: packId,
            packName: packName ? packName : "不分包",
            hasScore: true, // 是否评分
            list: [],
            headers: []
          };
          if (res.data.data && res.data.data.length > 0) {
            res.data.data.forEach(aItem => {
              aItem.supScore = aItem.supScore
                ? new BigNumber(aItem.supScore).toFormat(2)
                : aItem.supScore;
              aItem.sscScoreBOS = aItem.sscSupScoreBOS;
              aItem.sscSupScoreBOS.forEach(bItem => {
                bItem.sscScoreItemBOS = bItem.sscSupScoreItemBOS;
                // 将评分项排序保证每条数据对应正确
                bItem.sscScoreItemBOS.sort(function(a, b) {
                  return a.scoreItemId - b.scoreItemId;
                });
                bItem.sscSupScoreItemBOS.forEach(o => {
                  o.supScore = o.supScore
                    ? new BigNumber(o.supScore).toFormat(2)
                    : o.supScore;
                });
              });
            });
            obj.list = res.data.data;
            let flag = true;
            res.data.data[0].sscScoreBOS.forEach(item => {
              if (flag) {
                if (item.scoreItem === "0") {
                  flag = false;
                  obj.headers = Object.assign([], item.sscScoreItemBOS);
                }
              }
            });
          }
          resolve(obj);
        });
      });
    },
    viewBidFile(row) {
      this.formData.supPackQuoteId = row.supPackQuoteId;
      this.formData.supQuoteId = row.supQuoteId;
      this.formData.supCode = row.supCode;
      this.dialogVisible = true;
    },
    addOrEditData(item, type) {
      // type 0:新增 1：编辑
      this.$router.push({
        name: "addSkiiScore",
        query: {
          type: type,
          packId: item.packId,
          menuKey: this.$router.history.current.query.menuKey,
          active: this.active
        }
      });
    },
    dealExpertSupScoreSubmit() {
      this.$confirm(
        "您确定要提交吗？评分表提交后，此信息将不允许被编辑修改。",
        "提交评分确认",
        {
          distinguishCancelAndClose: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          customClass: "ccui-message-box-custom"
        }
      )
        .then(() => {
          qryExpertScorePackListApi({
            schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
              .schemeId,
            joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
              .joinExpertId,
            scoreItem: "0"
          }).then(res => {
            let noScoreFlag = false; // 是否存在正常的未评分包件
            res.data.data.notScorePack.forEach(item => {
              // 看是否流标 packStatus 1正常5流标
              if (item.packStatus == "1") {
                noScoreFlag = true;
              }
            });
            if (noScoreFlag) {
              this.$message({
                message:
                  "您还有评分未完成的包件，请您对每个包件中的供应商评分完毕后，再提交评分结果，谢谢您的配合！！",
                type: "error",
                duration: 3000,
                showClose: true,
                ccuiCustom: true
              });
              return;
            } else {
              dealExpertSupScoreSubmitApi({
                schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
                  .schemeId,
                joinExpertId: JSON.parse(
                  sessionStorage.getItem("expertSourceData")
                ).joinExpertId,
                scoreType: "0"
              }).then(res => {
                if (res.data.code == "0") {
                  this.init();
                  this.$message({
                    message: "评分表提交成功！",
                    type: "success",
                    duration: 3000,
                    showClose: true,
                    ccuiCustom: true
                  });
                }
              });
            }
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.fr {
  float: right;
}
.clear {
  clear: both;
}
.star {
  color: #ff1818;
}
.wd2 {
  width: 20px;
}
.wd6 {
  width: 60px;
}
.wd10 {
  width: 100px;
}
.wd20 {
  width: 200px;
}
/deep/ .el-table tr {
  td,
  th {
    height: 36px !important;
    line-height: 36px !important;
    //padding: 5px 10px !important;
    //box-sizing: border-box !important;
    //text-overflow: ellipsis !important;
    //white-space: nowrap;
  }
}
/deep/ .el-tabs__customize > .el-tabs__header {
  margin-bottom: 20px !important;
  padding-top: 20px !important;
}
/deep/.el-dialog {
  overflow: hidden;
  margin-top: 0px;
  width: calc(100% - 240px) !important;
  left: 100px !important;
  top: 45px !important;
  .el-dialog__body {
    max-height: calc(100vh - 130px - 94px - 20px) !important;
    height: calc(100vh - 130px - 94px - 20px) !important;
  }
}
/deep/ .el-table--border {
  th:last-of-type.gutter {
    display: table-cell !important;
    width: 0px !important;
  }
}
.tooltip-header {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  margin: 10px 0;
  line-height: 20px;
}
</style>
